import axios from "axios";
import { BASE_URL } from "@config/variables";

/**
 * Profile API Service
 * Centralized API calls for user profile management
 */

/**
 * Upload or update user profile image
 * @param {string} userId - User ID
 * @param {string} username - User email
 * @param {string} imageBase64 - Base64 encoded image string
 * @returns {Promise<Object>} Response with success status
 */
export const updateProfileImage = async (userId, username, imageBase64) => {
  const options = {
    url: `${BASE_URL}/services/data/v56.0/sobjects/User/${userId}`,
    method: "patch",
    data: { Photo__c: imageBase64 },
  };

  try {
    const response = await axios(options);
    if (response.status === 204) {
      return {
        success: true,
        message: "Profile image updated successfully",
      };
    }
    throw new Error("Failed to update profile image");
  } catch (error) {
    const isUnauthorized = error?.response?.status === 401;
    return {
      success: false,
      error: isUnauthorized ? "Session expired" : "Something went wrong",
      isUnauthorized,
    };
  }
};
